import authorization from './base/authorization';
import axios from 'axios';

export function exportLogs({
  schedule_time_id,
  branch_id,
  course_id,
  date,
  fileName
}) {
  const config = {
    responseType: 'blob',
    baseURL: process.env.VUE_APP_API_URL,
    method: 'get',
    url: `course/${course_id}/export`,
    ...authorization(),
    params: {
      schedule_time_id,
      branch_id,
      course_id,
      date
    }
  };

  return axios(config)
    .then(response => {
      var blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel;charset=utf-8'
      });
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = fileName + '.xlsx';
      document.body.appendChild(a);
      a.click();
    })
    .catch(error => {
      console.log(error);
    });
}

export default {
  exportLogs
};
